import React, { ReactNode } from 'react';
import styles from './assets/internal-screen.module.scss';
import classNames from 'classnames';
import InternalsGrid from './components/InternalsGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import RoleLayout from 'src/components/layout/RoleLayout';
import { IInternal } from 'src/types/internal';
import CreateInternalButton from './components/CreateInternalButton';
import Loader from '../../../../../../components/Loader';
import user from '../../../../../../services/user-auth';
import UserRole from '../../../../../../enumerables/user-role';

export interface StateProps {
    data: Paginated<IInternal>;
    providers: SelectObject[];
    inProgress: boolean;
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
    getDataCsv: (params: QueryParams) => void;
    getProviders: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

class InternalsList extends React.Component<Props> {
    componentDidMount() {
        this.props.getProviders({});
        // this.setState({ dataToCsV: groupDataToCsv(this.props.data) });
    }
    public render(): ReactNode {
        const { data, getData, providers, inProgress } = this.props;
        const isProvider = user.getRoles().includes(UserRole.ROLE_USER);
        const isSupervisor = user.getSupervisor();
        return (
            <RoleLayout>
                {isProvider && !isSupervisor ? null : <div className={'isGetCsv'}></div>}
                <div className={classNames(styles.pageHeading, 'pageHeading')}>
                    <h2 className={classNames(styles.headingTitle, 'pageHeadingTitle')}>
                        INTERNALS {data.totalCount ? '(' + data.totalCount + ')' : ''}
                    </h2>

                    <CreateInternalButton />
                </div>
                {inProgress ? <Loader /> : null}
                <div className={classNames(styles.list)}>
                    <InternalsGrid
                        providers={providers}
                        getDataCsv={this.props.getDataCsv}
                        data={data}
                        getData={getData}
                    />
                </div>
            </RoleLayout>
        );
    }
}

export default InternalsList;
